export default __webpack_public_path__ + "static/media/logo-waves.38004324.svg";